export default [
  {
    "id": "counter",
    "role": "countable",
    "singular": "counter",
    "plural": "counters",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "pencil",
    "role": "countable",
    "singular": "pencil",
    "plural": "pencils",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ball",
    "role": "countable",
    "singular": "ball",
    "plural": "balls",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "board",
    "role": "countable",
    "singular": "board",
    "plural": "boards",
    "tags": [
      "building-material"
    ]
  },
  {
    "id": "book",
    "role": "countable",
    "singular": "book",
    "plural": "books",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "sticker",
    "role": "countable",
    "singular": "sticker",
    "plural": "stickers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "marble",
    "role": "countable",
    "singular": "marble",
    "plural": "marbles",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "bead",
    "role": "countable",
    "singular": "bead",
    "plural": "beads",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "token",
    "role": "countable",
    "singular": "token",
    "plural": "tokens",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "rope",
    "role": "measurable",
    "singular": "rope",
    "plural": "ropes",
    "tags": [
      "length"
    ]
  },
  {
    "id": "water",
    "role": "measurable",
    "singular": "water",
    "plural": "waters",
    "tags": [
      "liquid"
    ]
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "bag",
    "role": "container",
    "singular": "bag",
    "plural": "bags",
    "tags": []
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "friend",
    "role": "person",
    "singular": "friend",
    "plural": "friends",
    "tags": []
  },
  {
    "id": "student",
    "role": "person",
    "singular": "student",
    "plural": "students",
    "tags": []
  },
  {
    "id": "practice session",
    "role": "action",
    "singular": "practice session",
    "plural": "practice sessions",
    "tags": []
  },
  {
    "id": "repair",
    "role": "action",
    "singular": "repair",
    "plural": "repairs",
    "tags": []
  },
  {
    "id": "bridge",
    "role": "structure",
    "singular": "bridge",
    "plural": "bridges",
    "tags": []
  },
  {
    "id": "fence",
    "role": "structure",
    "singular": "fence",
    "plural": "fences",
    "tags": []
  },
  {
    "id": "park",
    "role": "place",
    "singular": "park",
    "plural": "parks",
    "tags": []
  },
  {
    "id": "room",
    "role": "place",
    "singular": "room",
    "plural": "rooms",
    "tags": []
  },
  {
    "id": "child",
    "role": "person",
    "singular": "child",
    "plural": "children",
    "tags": []
  }
];
